import React from 'react';
import { Commons_Cms_DynamicPageQuery } from '../gql/graphql';
import Metadata from './metadata';

type Commons_Cms_DynamicPageQuery_Pages = Commons_Cms_DynamicPageQuery['pages'][0];

interface IProps {
  page: Commons_Cms_DynamicPageQuery_Pages;
}

export default function CmsPageMetadata({ page }: IProps) {
  return (
    <Metadata
      title={page.metaTitle || page.title}
      description={page.metaDescription || page.description}
      image={page.image?.imageUrl}
      metaImage={page.metaImage?.imageUrl}
      noIndex={page.noIndex}
    />
  );
}
